// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"e237e822","453":"732d7d58"}[chunkId] + ".chunk.js";
};